import { getRandom, sleep } from './utils';

export default async function selectFile(
  accept: string[] = [],
  multiple: boolean = false
): Promise<File[] | null> {
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = accept.join(',');
  fileInput.id = `file-${getRandom()}`;
  fileInput.multiple = multiple;
  fileInput.classList.add('hidden');
  document.body.appendChild(fileInput);

  const files = await new Promise<File[]>((resolve) => {
    fileInput.onclick = () => {
      document.body.onfocus = async () => {
        document.body.onfocus = null;
        await sleep(1000);
        if (!fileInput.value.length) resolve([]);
      };
    };
    fileInput.click();
    fileInput.onchange = async () => {
      fileInput.onchange = null;
      resolve(Array.from(fileInput.files || []));
    };
  });
  document.body.removeChild(fileInput);
  return files;
}
